"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportDialogProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var dashboardContexts_1 = require("../dashboardContexts");
/**
 * @internal
 */
exports.ExportDialogProvider = function () {
    var _a = dashboardContexts_1.useExportDialogContext(), closeDialog = _a.closeDialog, dialogConfig = _a.dialogConfig, isOpen = _a.isOpen;
    var intl = react_intl_1.useIntl();
    var originalOnClose = dialogConfig.onClose;
    var onClose = react_1.useCallback(function () {
        originalOnClose === null || originalOnClose === void 0 ? void 0 : originalOnClose();
        closeDialog();
    }, [originalOnClose, closeDialog]);
    return isOpen ? (react_1.default.createElement(sdk_ui_kit_1.ExportDialog, tslib_1.__assign({}, dialogConfig, { headline: intl.formatMessage({ id: "dialogs.export.headline" }), cancelButtonText: intl.formatMessage({ id: "cancel" }), submitButtonText: intl.formatMessage({ id: "dialogs.export.submit" }), filterContextText: intl.formatMessage({ id: "dialogs.export.includeFilters" }), filterContextTitle: intl.formatMessage({ id: "dialogs.export.filters" }), mergeHeadersText: intl.formatMessage({ id: "dialogs.export.mergeHeaders" }), mergeHeadersTitle: intl.formatMessage({ id: "dialogs.export.cells" }), onClose: onClose, onCancel: closeDialog }))) : null;
};
//# sourceMappingURL=ExportDialogProvider.js.map